<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <div class="page">
    <div
      class="mb-3"
      (click)="goBack()"
      style="cursor: pointer; width: fit-content"
    >
      <i class="bi bi-arrow-left me-2"></i>Back
    </div>
    <div class="header mb-4">
      <div>
        <h2>Generated Links</h2>
        <p>
          Every link shares the <b>testing</b> template — each can have its own
          audience, validity and rules.
        </p>
      </div>

      <button class="btn-add" (click)="openGenerateLinkBox()">
        <i class="bi bi-link-45deg"></i>
        Generate New Link
      </button>
    </div>

    <div class="tabs">
      <button
        class="tab"
        [class.active]="activeTab === AdminGenerateLinkStatus.ALL"
        (click)="activeTab = AdminGenerateLinkStatus.ALL"
      >
        All <span>{{ getCount(AdminGenerateLinkStatus.ALL) }}</span>
      </button>

      <button
        class="tab"
        [class.active]="activeTab === AdminGenerateLinkStatus.ACTIVE"
        (click)="activeTab = AdminGenerateLinkStatus.ACTIVE"
      >
        Active <span>{{ getCount(AdminGenerateLinkStatus.ACTIVE) }}</span>
      </button>

      <!-- <button
        class="tab"
        [class.active]="activeTab === AdminGenerateLinkStatus.SCHEDULED"
        (click)="activeTab = AdminGenerateLinkStatus.SCHEDULED"
      >
        Scheduled <span>{{ getCount(AdminGenerateLinkStatus.SCHEDULED) }}</span>
      </button> -->

      <button
        class="tab"
        [class.active]="activeTab === AdminGenerateLinkStatus.EXPIRED"
        (click)="activeTab = AdminGenerateLinkStatus.EXPIRED"
      >
        Expired <span>{{ getCount(AdminGenerateLinkStatus.EXPIRED) }}</span>
      </button>

      <button
        class="tab"
        [class.active]="activeTab === AdminGenerateLinkStatus.INACTIVE"
        (click)="activeTab = AdminGenerateLinkStatus.INACTIVE"
      >
        Disabled <span>{{ getCount(AdminGenerateLinkStatus.INACTIVE) }}</span>
      </button>
    </div>

    <ng-container *ngIf="filteredLinks.length > 0; else noLinksAvailable">
      <div class="table">
        <div class="table-header">
          <span>Link</span>
          <span>Status</span>
          <span>Validity</span>
          <span>Attempts</span>
          <span>Actions</span>
        </div>

        <div class="table-row" *ngFor="let generateLink of filteredLinks">
          <div class="link-info">
            <div class="title">{{ generateLink.link_name }}</div>
            <div class="url">{{ generateLink.url }}</div>
            <!-- <div class="meta">Public link</div> -->
            <div class="meta">
              <i class="bi bi-envelope-fill me-1"></i>
              {{ generateLink.invited_emails.length }} invited
            </div>
          </div>

          <div>
            <span
              class="badge"
              [ngClass]="{
                active:
                  generateLink.status.toLowerCase() ===
                  AdminGenerateLinkStatus.ACTIVE,
                expired:
                  generateLink.status.toLowerCase() ===
                  AdminGenerateLinkStatus.EXPIRED,
                inactive:
                  generateLink.status.toLowerCase() ===
                  AdminGenerateLinkStatus.INACTIVE,
                scheduled:
                  generateLink.status.toLowerCase() ===
                  AdminGenerateLinkStatus.SCHEDULED,
              }"
            >
              {{ generateLink.status }}
            </span>
          </div>

          <div class="validity">
            <small
              ><i class="bi bi-calendar-date me-2 cal"></i
              >{{ generateLink.start_date | date: dateTimeFormat }}</small
            >
            <small
              ><i class="bi bi-clock me-2 clock"></i
              >{{ generateLink.end_date | date: dateTimeFormat }}</small
            >
          </div>

          <div>
            <i class="bi bi-people"></i>{{ generateLink.attempts_count }}
          </div>

          <div class="actions">
            <button class="btn" (click)="copyLink(generateLink.url)">
              <i class="bi bi-clipboard"></i>
              Copy Link
            </button>
            <button class="btn" (click)="openInviteDialogBox(generateLink)">
              <i class="bi bi-person-plus"></i>
              Invite
            </button>

            <button
              class="btn"
              (click)="goToAssessmentDetailPage(generateLink.link_id)"
            >
              <i class="bi bi-eye"></i>
              Attempts
            </button>

            <button class="btn" (click)="openExtendDialog(generateLink)">
              <i class="bi bi-calendar-plus"></i>
              Extend Expiry
            </button>

            <ng-container
              *ngIf="
                generateLink.status.toLowerCase() ===
                AdminGenerateLinkStatus.ACTIVE
              "
            >
              <button
                class="btn danger3"
                (click)="openDisableDialogBox(generateLink.link_id)"
              >
                <i class="bi bi-slash-circle"></i>
                Disable
              </button>
            </ng-container>

            <ng-container
              *ngIf="
                generateLink.status.toLowerCase() ===
                AdminGenerateLinkStatus.INACTIVE
              "
            >
              <button
                class="btn enable"
                (click)="openEnableDialogBox(generateLink.link_id)"
              >
                <i class="bi bi-check2-circle"></i>
                Enable
              </button>
            </ng-container>

            <!-- <ng-container  *ngIf="generateLink.status.toLowerCase() === AdminGenerateLinkStatus.EXPIRED">
            <button class="btn danger2">
              <i class="bi bi-slash-circle"></i>
               Disabled
            </button>
            </ng-container> -->
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #noLinksAvailable>
      <div class="text-center no-links">
        <h6>{{ emptyMessage }}</h6>

        <p class="text-center">
          <ng-container [ngSwitch]="activeTab">
            <span *ngSwitchCase="AdminGenerateLinkStatus.ACTIVE"
              >Generate or activate a link to see it here.</span
            >
            <span *ngSwitchCase="AdminGenerateLinkStatus.EXPIRED"
              >Expired links will appear here once they pass validity.</span
            >
            <span *ngSwitchCase="AdminGenerateLinkStatus.SCHEDULED"
              >Links scheduled for future will show here.</span
            >
            <span *ngSwitchCase="AdminGenerateLinkStatus.INACTIVE"
              >Disabled links will be listed here.</span
            >
            <span *ngSwitchDefault
              >Generate a link to start sharing this assessment.</span
            >
          </ng-container>
        </p>

        <button
          *ngIf="
            activeTab === AdminGenerateLinkStatus.ALL ||
            activeTab === AdminGenerateLinkStatus.ACTIVE
          "
          class="btn-add text-center"
          (click)="openGenerateLinkBox()"
        >
          <i class="bi bi-link-45deg"></i>
          Generate Link
        </button>
      </div>
    </ng-template>
  </div>
  <div class="pagination-wrapper" *ngIf="totalRecords > limit && !isLoading">
    <button
      class="nav-btn"
      [disabled]="page === 1"
      (click)="changePage(page - 1)"
    >
      ‹
    </button>

    <div class="page-pill">
      <button
        *ngFor="let p of visiblePages"
        class="page-number"
        [class.active]="p === page"
        (click)="changePage(p)"
      >
        {{ p }}
      </button>
    </div>

    <button
      class="nav-btn"
      [disabled]="page === totalPages"
      (click)="changePage(page + 1)"
    >
      ›
    </button>
  </div>

  <div class="pagination-skeleton" *ngIf="isLoading">
    <span></span>
    <span></span>
    <span></span>
  </div>
</ng-template>
